import $ from 'jquery';

export default class IframesController {
    static adjustIframes() {
        $('iframe:not(.no-resize)').each(function () {
            const $this = $(this);
            let proportion = $this.data('proportion');
            const w = parseInt($this.attr('width'), 10);
            const parentW = parseInt($this.parent().width(), 10);
            if (w < 10) return;
            if (!proportion || isNaN(proportion)) {
                proportion = $this.attr('height') / w;
                $this.data('proportion', proportion);
            }
            if (parentW !== w) {
                $this.css(`{width: ${parentW}px, height: ${Math.round(parentW * proportion)}px}`);
            }
        });
    }

    static init() {
        $(window).on('resize load', () => {
            IframesController.adjustIframes();
        });
    }
}
